<script>
	export default {
		name: 'tfooter'
	}
</script>

<template>
	<div id="tfooter" class="row">
		<div class="container">
			<section class="section">
				<div class="wrap-logos">
					<ul class="wrap-votolegal">
						<li>
							<a href="/" class="votolegal"></a>
						</li>
					</ul>
				</div>

				<div class="wrap-informations">
					<p>
						<a href="https://votolegal.com.br" target="_blank">Voto Legal</a> é uma plataforma de doações. Todas são registradas na blockchain da Decred com objetivo de garantir a autenticidade das transações, promovendo a confiabilidade no processo de doação eleitoral.
					</p>
					<p>
						<strong>
              © 2016-2020 <a href="https://votolegal.com.br" target="_blank">Voto Legal</a>
              • Uma iniciativa <a href="http://appcivico.com" target="_blank">AppCívico</a> - Tecnologias Cívicas
              • <a href="https://comunidade.appcivico.com/c/voto-legal/" target="_blank">Comunidade</a>
              • <a href="https://docs.google.com/forms/d/e/1FAIpQLSfy6O6A80gtkCM---KuOwA2PsLZwh4GapJLrflP9TVZ8CgkPg/viewform" target="_blank">Afiliados</a>
            </strong>
					</p>
				</div>
			</section>
		</div>
	</div>
</template>

<style lang="scss">

#tfooter {
	position: relative;
	background-color: rgb(45, 227, 109);
}

#tfooter section {
	padding-top: 8em;
	padding-bottom: 3em;

	a {
		font-weight: bold;
		text-decoration: none;
		color: rgb(51, 102, 102);
	}

	a:hover {
		color: rgb(255, 255, 255);
		text-decoration: underline;
	}
}

.wrap-logos {
	text-align: center;
	margin: 0;
}

.wrap-logos ul {
	margin: auto;
}

.wrap-logos	li {
	float: none;
	margin-top: 30px;
	font-size: 19px;

	a {
		color: #4bb958;

		&:hover {
			color: #676767;
		}
	}
}

.wrap-votolegal a {
	margin: 0;
	margin-right: auto;
	margin-left: auto;
	display: block;
	padding: 0;

	&.votolegal {
		background: url('../../img/logo/votolegal-white.png');
		background-repeat: no-repeat;
		width: 171px;
		height: 49px;
	}
}

.wrap-social li {
	display: inline-block;
	border-radius: 50%;
	margin-top: 1.42em;
	margin-left: 0.5em;
	margin-right: 0.5em;
}

.wrap-social a {
	display: block;
	padding: 0;

	&.twitter {
		background: url('../../img/icons/twitter-icon.png');
		width: 26px;
		height: 21px;
	}

	&.youtube {
		background: url('../../img/icons/youtube-icon.png');
		width: 31px;
		height: 21px;
	}

	&.facebook {
		background: url('../../img/icons/facebook-icon.png');
		width: 12px;
		height: 22px;
	}
}

.wrap-informations {
	margin-top: 2.3125em;
	color: rgb(51, 102, 102);

	text-align: center;
	& p + p {
		margin-top: 1.625em;
	}

	.candidate-footer & {
			color: rgb(255, 255, 255);
	}
}

</style>



// WEBPACK FOOTER //
// _source/javascript/components/tfooter.vue